import {PAGES} from "../../../../../core/consts";
import {CompetitionIndexPageRouteMetaDataModel} from "./competition-index-page.route.meta-data.model";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionIndexPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.index,
      componentImport: () => import("../components/competition-index-page" /* webpackChunkName: "competition-index-page" */ ),
      metadataType: CompetitionIndexPageRouteMetaDataModel
    });

    this.index = true;
  }
}